import moment from "jalali-moment";
import { DateObject } from "react-multi-date-picker";
import { toEnDigit } from "./text";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

export const convertGregorianToJalali = (gregorianDate) => {
  return new Date(gregorianDate).toLocaleDateString("fa-IR");
};

export const getLast7Days = () => {
  const today = new Date();
  const days = [];
  for (let index = 1; index <= 7; index++) {
    days.push(today.toLocaleDateString("fa-IR", { weekday: "long" }));
    today.setDate(today.getDate() - 1);
  }
  return days;
};

export const convertDateToEnglish = (date, seprator) => {
  if (date) {
    const year = date.year;
    const mounth = date.month.number;
    const day = date.day;

    const enDate = moment
      .from(`${year}/${mounth}/${day}`, "fa", "YYYY/MM/DD")
      .format(`YYYY${seprator}MM${seprator}DD`);

    return enDate;
  }
};

export const getCalenderLastDays = (number) => {
  let date = new DateObject({ calendar: persian, locale: persian_fa });
  let updatedDate = new DateObject({
    calendar: persian,
    locale: persian_fa,
  }).subtract(number, "days");
  if (number <= 1) {
    return [updatedDate];
  } else {
    return [updatedDate, date];
  }
};

export const convertTimeZoneToPersian = (timeZone, justTime = false) => {
  if (!timeZone) return "";

  const options = { year: "numeric", month: "long", day: "numeric" };
  const date = new Date(timeZone).toLocaleDateString("fa-IR", options);

  const time = new Date(timeZone).toLocaleTimeString("fa-IR", {
    hour: "2-digit",
    minute: "2-digit",
  });

  if (justTime) return `${time}`;

  return `${date} ساعت ${time}`;
};

// converts dates from jalali to gregorian and vice versa based on input and output formats. by default it converts jalali input to gregorian output.
const convertDates = (
  date,
  inputFormat = "jYYYY/jMM/jDD",
  outputFormat = "YYYY/MM/DD"
) => {
  return moment(date, inputFormat).format(outputFormat);
};

// gets time in for example ' ۱۴۰۲/۷/۲۷ ۱۶:۵۳ ' form and convert it into garegorian date
export const convertDateAndTimeInPersianFormToGaregorianForm = (
  time,
  locale = "fa",
  justTime
) => {
  if (locale === "fa") return time;

  const digitForm = toEnDigit(time);

  if (digitForm.length <= 5) return digitForm;

  const dateWithEnglishDigits = digitForm.split(" ")[0];
  const timeWithEnglishDigits = digitForm.split(" ")[1];

  const convertedDate = convertDates(dateWithEnglishDigits);

  if (justTime) return timeWithEnglishDigits;

  return `${convertedDate} ${timeWithEnglishDigits}`;
};

export const getTimeBasedOnLocale = (locale = "fa", justTime, inputTime) => {
  const dateObject = inputTime ? new Date(inputTime) : new Date();

  if (locale === "fa") return convertTimeZoneToPersian(dateObject, justTime);

  const options = { year: "numeric", month: "long", day: "numeric" };

  const date = dateObject.toLocaleDateString([], options);
  const time = dateObject.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return justTime ? time : date;
};

// get start and end (date object) and returs day elapsed time in Hour,Min and second

/**
 *
 * @param {Object} startDate - starting Date object
 * @param {Object} endDate - ending date object
 * @param {string} largestUnit - largest determining unit. if it is day, hours will be splitted by 24
 * @returns Object
 */
export const getElapsedTime = (startDate, endDate, largestUnit = "hr") => {
  const diffMs = endDate - startDate;

  const MS_PER_MIN = 60 * 1000;

  const MS_PER_HOUR = MS_PER_MIN * 60;

  const MS_PER_DAY = MS_PER_HOUR * 24;

  const diffDays = Math.floor(diffMs / MS_PER_DAY);

  const diffHours =
    largestUnit === "day"
      ? Math.floor((diffMs % MS_PER_DAY) / MS_PER_HOUR)
      : Math.floor(diffMs / MS_PER_HOUR);

  const diffMinutes = Math.floor((diffMs % MS_PER_HOUR) / MS_PER_MIN);

  const diffSeconds = Math.floor((diffMs % MS_PER_MIN) / 1000);

  return {
    days: diffDays,
    hours: diffHours,
    minutes: diffMinutes,
    seconds: diffSeconds,
  };
};

export const getTimeKey = (
  greg_time_key = new Date()?.toISOString()?.split("T")?.[0]
) => {
  const formatted_time_key = moment(greg_time_key)
    .locale("fa-IR")
    .format("dddd jDD jMMMM");
  return formatted_time_key;
};
